import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from './core/services/translation-loader.service';


import { locale as navigationSpanish } from './i18n/es';
import { locale as navigationEnglish } from './i18n/en';
import { FuseSplashScreenService } from './core/services/splash-screen.service';

@Component({
    selector   : 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    constructor(
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService
    )
    {
        // Add languages
        this.translate.addLangs(['es', 'en']);

        // Set the default language
        this.translate.setDefaultLang('es');

        // Use a language
        this.translate.use('en');

         // Set the navigation translations
         this.translationLoader.loadTranslations(navigationSpanish, navigationEnglish);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts